import React, { useEffect } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ContainerOutlined,
  CalendarOutlined,
  FileTextOutlined,
  getTwoToneColor,
  setTwoToneColor,
} from "@ant-design/icons";
import { Layout, Menu, Row, Col, Button } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
// import Sider from "antd/es/layout/Sider";
const { Header, Content, Sider } = Layout;

function getItem(label, key, icon, children, onClick) {
  return {
    key,
    icon,
    children,
    label,
    onClick,
  };
}

export default function LayoutMain(props) {
  const navigate = useNavigate();
  const listMenu = [
    getItem(
      "Device in Room",
      "/deviceroom",
      <ContainerOutlined style={{ fontSize: "24px" }} />,
      null,
      () => {
        navigate("/deviceroom");
      }
    ),
    getItem(
      "Device in Home",
      "/devicehome",
      <ContainerOutlined style={{ fontSize: "24px" }} />,
      null,
      () => {
        navigate("/devicehome");
      }
    ),
    getItem(
      "Edit Device",
      "/devicehome",
      // "/editdevice",
      <ContainerOutlined style={{ fontSize: "24px" }} />,
      null,
      () => {
        navigate("/devicehome");
        // navigate("/editdevice");
      }
    ),
    getItem(
      "Master Name",
      "/mastername",
      // "/editdevice",
      <ContainerOutlined style={{ fontSize: "24px" }} />,
      null,
      () => {
        navigate("/mastername");
        // navigate("/editdevice");
      }
    ),
  ];
  useEffect(() => {}, []);

  return (
    <Layout>
      <Sider
        className="menu"
        width={250}
        trigger={null}
        collapsible
        style={{
          background: "rgba(255,255,255)",
          borderRight: "1px solid rgba(0, 0, 0, 0.13)",
        }}
      >
        <Menu
          //   theme="dark"
          mode="inline"
          // defaultSelectedKeys={[listMenu]}
          // defaultOpenKeys={["/deviceroom"]}
          // selectedKeys={[listMenu]}
          items={listMenu}
          style={styles.menu}
        />
        <div
          style={{
            textAlign: "center",
            padding: "10px 0",
            fontSize: 12,
            color: "#888",
            borderTop: "1px solid rgba(0,0,0,0.1)",
            background: "#fafafa",
          }}
        >
          Version 1.4
        </div>
      </Sider>
      <Layout style={{ minHeight: "100vh" }}>
        <Content>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
    // <div style={{ background: "#fff", height: "100vh" }}>
    //   <Outlet />
    // </div>
  );
}

const styles = {
  menu: {
    color: "#2A5885",
    fontSize: "16px",
  },
};
